import { render, staticRenderFns } from "./FormPackage.vue?vue&type=template&id=76d3f570&"
import script from "./FormPackage.vue?vue&type=script&lang=js&"
export * from "./FormPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports